import Layout from "../components/Layout";
import Home from "./Home";
import Trials from "./Trials";
import Accounts from "./Accounts";
import ArdorioTrials from "./ArdorioTrials";
import ShiftOSTrials from "./ShiftOSTrials";
import ShiftOSTrialDetail from "./ShiftOSTrialDetail";
import ArdorioAccounts from "./ArdorioAccounts";
import ShiftOSAccounts from "./ShiftOSAccounts";
import Provision from "./Provision";
import Account from "./Account";
import Plans from "./Plans";
import Salespeople from "./Salespeople";
import QuestionLibrary from "./QuestionLibrary";
import RoleGuard from "../components/RoleGuard";
import { Route, Routes, useLocation } from "react-router-dom";
import {
  Users,
  Activity,
  Shield,
  Settings,
  CreditCard,
  UserCog,
  BookOpen,
  Briefcase,
} from "lucide-react";

const navigationItems = [
  {
    title: "Leads",
    icon: Users,
    path: "/",
  },
  {
    title: "Ardorio Trials",
    icon: Activity,
    path: "/trials/ardorio",
  },
  {
    title: "ShiftOS Trials",
    icon: Briefcase,
    path: "/trials/shiftos",
  },
  {
    title: "Ardorio Accounts",
    icon: Shield,
    path: "/accounts/ardorio",
  },
  {
    title: "ShiftOS Accounts",
    icon: Briefcase,
    path: "/accounts/shiftos",
  },
  {
    title: "Provision",
    icon: Settings,
    path: "/provision",
    superAdminOnly: true,
  },
  {
    title: "Plans",
    icon: CreditCard,
    path: "/plans",
    adminOnly: true,
  },
  {
    title: "Salespeople",
    icon: UserCog,
    path: "/salespeople",
    adminOnly: true,
  },
  {
    title: "Question Library",
    icon: BookOpen,
    path: "/question-library",
    adminOnly: true,
  },
];

// Create a wrapper component that uses useLocation inside the Router context
function PagesContent() {
  const location = useLocation();

  return (
    <Layout navigationItems={navigationItems} currentPath={location.pathname}>
      <Routes>
        <Route index element={<Home />} />
        {/* Legacy routes for backward compatibility */}
        <Route path="/trials" element={<Trials />} />
        <Route path="/accounts" element={<Accounts />} />
        {/* New product-specific routes */}
        <Route path="/trials/ardorio" element={<ArdorioTrials />} />
        <Route path="/trials/shiftos" element={<ShiftOSTrials />} />
        <Route path="/accounts/ardorio" element={<ArdorioAccounts />} />
        <Route path="/accounts/shiftos" element={<ShiftOSAccounts />} />
        <Route
          path="/provision"
          element={
            <RoleGuard requiredRole="super_admin">
              <Provision />
            </RoleGuard>
          }
        />
        <Route
          path="/plans"
          element={
            <RoleGuard requiredRole="admin">
              <Plans />
            </RoleGuard>
          }
        />
        <Route
          path="/salespeople"
          element={
            <RoleGuard requiredRole="admin">
              <Salespeople />
            </RoleGuard>
          }
        />
        <Route
          path="/question-library"
          element={
            <RoleGuard requiredRole="admin">
              <QuestionLibrary />
            </RoleGuard>
          }
        />
        <Route path="/shiftos-trial/:id" element={<ShiftOSTrialDetail />} />
        <Route path="/:accountId/*" element={<Account />} />
      </Routes>
    </Layout>
  );
}

export default function Pages() {
  return <PagesContent />;
}
